module.exports = __webpack_public_path__ + "static/media/S3N1-1.6506842e.svg";